import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=4e0a5a37&"
import script from "./Logout.vue?vue&type=script&setup=true&lang=js&"
export * from "./Logout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports